export const servicesList = "SERVICES_LIST";